import React from 'react';

import Button from '../Button/Button';

import ColumnContent from './ColumnContent';

import MarkdownContent from '../MarkdownContent';

// SVGs
import { ReactComponent as SVGsmartphone } from '../../assets/svg/smartphone.svg';
import { ReactComponent as SVGstopwatch } from '../../assets/svg/stopwatch.svg';
import { ReactComponent as SVGmedal } from '../../assets/svg/medal.svg';
import { ReactComponent as SVGvideoplayer } from '../../assets/svg/video-player.svg';

export default function DigitalLearning(props) {
	const { blocks } = props;

	return (
		<section className="section-block digital_learning" id="nos-solutions">
			<div className="container">
				<header>
					<MarkdownContent>
						{blocks.digital_learning_title.body}
					</MarkdownContent>
				</header>
				<div className="row">
					<div className="col-xs-12 col-sm-6 col-md-3 column column1">
						<div className="column__inner">
							<ColumnContent
								link={
									blocks.digital_learning_column1.frontmatter
										.linkURL
								}
								title={
									blocks.digital_learning_column1.frontmatter
										.title
								}
								content={blocks.digital_learning_column1.body}
								figure={<SVGsmartphone />}
							/>
						</div>
					</div>
					<div className="col-xs-12 col-sm-6 col-md-3 column column2">
						<div className="column__inner">
							<ColumnContent
								link={
									blocks.digital_learning_column2.frontmatter
										.linkURL
								}
								title={
									blocks.digital_learning_column2.frontmatter
										.title
								}
								content={blocks.digital_learning_column2.body}
								figure={<SVGstopwatch />}
							/>
						</div>
					</div>
					<div className="clearfix visible-sm-block"></div>
					<div className="col-xs-12 col-sm-6 col-md-3 column column3">
						<div className="column__inner">
							<ColumnContent
								link={
									blocks.digital_learning_column3.frontmatter
										.linkURL
								}
								title={
									blocks.digital_learning_column3.frontmatter
										.title
								}
								content={blocks.digital_learning_column3.body}
								figure={<SVGmedal />}
							/>
						</div>
					</div>
					<div className="col-xs-12 col-sm-6 col-md-3 column column4">
						<div className="column__inner">
							<ColumnContent
								link={
									blocks.digital_learning_column4.frontmatter
										.linkURL
								}
								title={
									blocks.digital_learning_column4.frontmatter
										.title
								}
								content={blocks.digital_learning_column4.body}
								figure={<SVGvideoplayer />}
							/>
						</div>
					</div>
					<div className="col-xs-12 outro">
						<p>
							<Button
								href={
									blocks.digital_learning_outro.frontmatter
										.linkURL
								}
								className="btn-primary btn-lg"
								sfx="rising-pops"
							>
								{
									blocks.digital_learning_outro.frontmatter
										.linkTitle
								}
							</Button>
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
